module.exports = __webpack_public_path__ + "media/images/emblems/Fischingen(Turgovio)-Blazono-72302fc4067e19e77cd7de0de530332e.png";